import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';

export const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div
      data-testid="not-found-page"
      className="flex flex-col items-center justify-center text-center"
      style={{ minHeight: '100vh', background: '#F8FAFC' }}
    >
      <div className="flex flex-col items-center max-w-[560px] px-8">
        {/* 404 大数字 */}
        <div
          className="font-bold leading-none mb-6"
          style={{ fontSize: 96, color: '#0a7a72', letterSpacing: '-2px' }}
        >
          404
        </div>

        <h1
          className="font-bold mb-4 leading-snug"
          style={{ fontSize: 24, color: '#0F172A' }}
          data-testid="not-found-title"
        >
          ページが見つかりません
        </h1>

        <p
          className="leading-relaxed mb-8"
          style={{ fontSize: 14, color: '#64748B', maxWidth: 400 }}
        >
          お探しのページは移動または削除された可能性があります。URLをご確認のうえ、もう一度お試しください。
        </p>

        <div className="flex items-center gap-3">
          <Button
            variant="outline"
            onClick={() => navigate(-1)}
            data-testid="not-found-prev-button"
          >
            前のページに戻る
          </Button>
          <Link to="/">
            <Button data-testid="not-found-back-button">ホームに戻る</Button>
          </Link>
        </div>

        <p className="mt-5 text-xs" style={{ color: '#94A3B8' }}>
          エラーコード: #ENG404
        </p>
      </div>
    </div>
  );
};
